import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getValueAssessment, UpdateUser } from "../api/api";
import Swal from "sweetalert2";
import bgImage from "../../assets/images/brown-background.jpg";
import "../ValuesAssessment/ValuesAssessment.css";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";

const ValuesAssessment = () => {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const questionsPerPage = 1;

  useEffect(() => {
    const fetchValueAssessment = async () => {
      try {
        const response = await getValueAssessment();
        console.log("valueAssesment", JSON.stringify(response));
        if (response?.success) {
          const formattedQuestions = response.data.map((item) => ({
            id: item.id.toString(),
            question: item.question,
            options: item.answers.map((ans) => ({
              id: ans.id.toString(),
              answer: ans.answer,
              category_id: ans.category_id,
            })),
          }));
          setQuestions(formattedQuestions);
        } else {
          Swal.fire(
            "Error",
            "Failed to fetch Value Assessment Questions",
            "error"
          );
        }
      } catch (error) {
        console.error("Error fetching assessment:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchValueAssessment();
  }, []);

  const handleOptionSelect = (questionId, optionId) => {
    setSelectedAnswers((prev) => {
      if (prev[questionId] === optionId) {
        const updated = { ...prev };
        delete updated[questionId];
        return updated;
      }
      return { ...prev, [questionId]: optionId };
    });
  };

  const handleSubmit = () => {
    const unanswered = questions.filter((q) => !selectedAnswers[q.id]);
    if (unanswered.length > 0) {
      Swal.fire("Please answer all questions", "", "warning");
    } else {
      const summary = Object.entries(selectedAnswers)
        .map(([id, optionId]) => {
          const question = questions.find((q) => q.id === id);
          const option = question?.options.find((opt) => opt.id === optionId);
          return `Q${questions.findIndex((q) => q.id === id) + 1}: ${
            question?.question
          }<br>Ans: ${option?.answer}`;
        })
        .join("<br><br>");

      Swal.fire({
        title: "Selected Answers",
        html: `<div style="text-align:left;">${summary}</div>`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Submit",
        confirmButtonColor: "#058787",
      }).then((result) => {
        if (result.isConfirmed) {
          submitAssessment();
        }
      });
    }
  };

  const submitAssessment = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      const userId = userData?.id || userData?._id;

      const formattedAnswers = Object.entries(selectedAnswers).map(
        ([questionId, optionId]) => ({
          question_id: questionId, // send as string or convert with Number()
          option_index: optionId,
        })
      );

      const payload = {
        user_id: userId,
        userAnswersValue: formattedAnswers,
        profile_completion_status: "userAnswersIQ",
      };

      console.log("sendValue", payload);
      const response = await UpdateUser(payload);
      console.log("api response", JSON.stringify(response));

      if (response?.success) {
        navigate("/IQAssessment");
      } else {
        Swal.fire("Error", response.message, "error");
      }
    } catch (error) {
      console.error("Error submitting assessment:", error);
      Swal.fire("Error", "Submission failed", "error");
    }
  };

  const startIndex = currentPage * questionsPerPage;
  const currentQuestions = questions.slice(
    startIndex,
    startIndex + questionsPerPage
  );
  const isNextEnabled = !!selectedAnswers[currentQuestions[0]?.id];
  const unansweredQuestions = questions.filter((q) => !selectedAnswers[q.id]);

  if (isLoading) {
    return <div>Loading questions...</div>;
  }

  return (
    <div
      className="ValuesAssessmentcontainer sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="valueSmallContainer">
          <h1 className="Valuetitle">Values Assessment</h1>

          {currentQuestions.map((question, index) => (
            <div key={question.id} className="valuequestion-container">
              <p className="valuequestion-text">{`Q${startIndex + index + 1}: ${
                question.question
              }`}</p>
              {question.options.map((option) => (
                <div
                  key={option.id}
                  className={`valueoption-container ${
                    selectedAnswers[question.id] === option.id
                      ? "selected-option"
                      : ""
                  }`}
                  onClick={() =>
                    handleOptionSelect(
                      question.id.toString(),
                      option.id.toString()
                    )
                  }
                >
                  <div
                    className={`valueradio-button ${
                      selectedAnswers[question.id] === option.id
                        ? "selected-radio-button"
                        : ""
                    }`}
                  />
                  <p className="valueoption-text">{option.answer}</p>
                </div>
              ))}
            </div>
          ))}

          <div className="valuenavigation-container">
            {currentPage > 0 && (
              <button
                className="valueprevious-button"
                onClick={() => setCurrentPage((prev) => prev - 1)}
              >
                Previous
              </button>
            )}
            {currentPage <
            Math.ceil(questions.length / questionsPerPage) - 1 ? (
              <button
                className={`valuenavigation-button ${
                  !isNextEnabled ? "disabled-button" : ""
                }`}
                onClick={() => setCurrentPage((prev) => prev + 1)}
                disabled={!isNextEnabled}
              >
                Next
              </button>
            ) : (
              <button
                className="valuesubmit-button"
                onClick={handleSubmit}
                disabled={unansweredQuestions.length > 0}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValuesAssessment;
